module.exports = __webpack_public_path__ + "img/Aadhar Card.630e50a5.svg";